import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { createTheme, Theme, ThemeProvider } from '@mui/material'
import { green, grey } from '@mui/material/colors'

import App from '../src/App'
import { Provider } from 'react-redux'
import { store } from './app/store'
import MainGuard from './mainGuard'
import NewRoomGuard from './newRoomGuard'

const theme: Theme = createTheme({
	palette: {
		primary: {
			contrastText: grey[100],
			main: green[600],
		},
		secondary: {
			main: grey[100],
			contrastText: green[600],
		},
	},
	typography: {
		fontFamily: [
			"IBM Plex Sans Hebrew",
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif'
		].join(','),
	}
});


export default function Router () {
	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<BrowserRouter>
					<Routes>
						<Route path='/' element={<App />} />
						<Route path='/new' element={<NewRoomGuard />} />
						<Route path='/main' element={<MainGuard />} />
					</Routes>
				</BrowserRouter>
			</ThemeProvider>
		</Provider>
	)
}
